<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title d-flex align-items-center">
        <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
          <inline-svg src="media/icons/duotune/ecommerce/ecm002.svg" />
        </span>
        <h3 class="fw-bold m-0 text-gray-800">Faturamentos</h3>
      </div>
      <div
        v-if="this.modal === true"
        class="btn btn-icon btn-sm btn-active-light-primary mt-6"
        data-bs-dismiss="modal"
        @click="this.$emit('fecharFaturamento', false)"
      >
        <span class="svg-icon svg-icon-2x">
          <img src="media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </div>
    <div class="card-body p-0">
      <div
        v-if="this.errosValidacaoGeral.length"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisarFaturamentos"
              type="text"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid ps-15"
              placeholder="Pesquisar Faturamentos"
            />
          </div>
        </div>
        <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
          <button
            v-if="this.modal === false"
            @click="this.$refs.tableFaturamento.exportarExcel()"
            type="button"
            class="btn btn-sm btn-light-primary"
          >
            <span class="svg-icon svg-icon-2">
              <inline-svg src="media/icons/duotune/arrows/arr078.svg" />
            </span>
            Exportar
          </button>
          <router-link
            v-if="this.adicionar && this.modal === false"
            to="/movimentacao/faturamento/editar"
            class="btn btn-sm btn-primary"
            ><span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen041.svg" /></span
            >Adicionar</router-link
          >
          <button
            v-if="this.adicionar && this.modal === true"
            @click="this.$emit('adicionarFaturamento')"
            class="btn btn-sm btn-primary"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen041.svg" /></span
            >Adicionar
          </button>
          <div
            v-if="this.checkedFaturamentos.length > 0"
            class="d-flex justify-content-end align-items-center"
            data-kt-customer-table-toolbar="selected"
          >
            <div class="fw-bolder me-5">
              <span class="me-2">{{ checkedFaturamentos.length }}</span
              >Selecionado(s)
            </div>
            <button
              v-if="this.excluir && this.modal === false"
              type="button"
              class="btn btn-sm btn-danger"
              @click="deleteSelecionados()"
            >
              Excluír Selecionado(s)
            </button>
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="tableFaturamento"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhum faturamento encontrado"
          v-on:checked-rows="checkedFaturamentos = $event"
          :colors="true"
        >
          <template v-slot:cell-checkbox="{ row: faturamento }">
            <div
              class="form-check form-check-sm form-check-custom form-check-solid"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="faturamento.id"
                v-model="checkedFaturamentos"
              />
            </div>
          </template>
          <template
            v-slot:cell-FaturamentoClienteClienteFoto="{ row: faturamento }"
          >
            <div
              v-if="
                faturamento.FaturamentoCliente &&
                faturamento.FaturamentoCliente.Cliente &&
                faturamento.FaturamentoCliente.Cliente.foto
                  ? faturamento.FaturamentoCliente.Cliente.foto
                  : ''
              "
              class="symbol symbol-50px"
            >
              <div
                class="symbol-label fs-2 fw-bold bg-light-dark"
                :style="{
                  'background-image': `url(${
                    this.$utils.getUrl() +
                    faturamento.FaturamentoCliente.Cliente.foto
                  })`,
                }"
              ></div>
            </div>
            <div v-else class="symbol symbol-50px">
              <div :class="['symbol-label fs-2 fw-bold ' + faturamento.color]">
                {{
                  faturamento.FaturamentoCliente &&
                  faturamento.FaturamentoCliente.nome
                    ? faturamento.FaturamentoCliente.nome
                        .substring(0, 1)
                        .toUpperCase()
                    : ""
                }}
              </div>
            </div>
          </template>
          <template v-slot:cell-id="{ row: faturamento }">
            <div class="text-dark fw-bolder">
              {{ faturamento.id }}
            </div>
          </template>
          <template v-slot:cell-FaturamentoClienteNome="{ row: faturamento }">
            <div class="min-w-150px align-middle">
              <div>
                <span class="text-dark text-hover-primary mb-1">
                  {{
                    faturamento.FaturamentoCliente &&
                    faturamento.FaturamentoCliente.nome
                      ? faturamento.FaturamentoCliente.nome
                      : ""
                  }}
                </span>
                <span class="text-muted fw-bold d-block">
                  {{
                    faturamento.FaturamentoCliente &&
                    faturamento.FaturamentoCliente.cpf_cnpj
                      ? faturamento.FaturamentoCliente.cpf_cnpj.length === 11
                        ? this.$utils.setMask(
                            faturamento.FaturamentoCliente.cpf_cnpj,
                            "###.###.###-##",
                            true
                          )
                        : this.$utils.setMask(
                            faturamento.FaturamentoCliente.cpf_cnpj,
                            "##.###.###/####-##",
                            true
                          )
                      : ""
                  }}
                </span>
              </div>
            </div>
          </template>
          <template v-slot:cell-status="{ row: faturamento }">
            <span
              :class="[
                faturamento.status_nfe
                  ? this.getStatusColor(faturamento.status_nfe)
                  : '',
              ]"
              >{{ faturamento.status_nfe }}</span
            >
          </template>
          <template v-slot:cell-total="{ row: faturamento }">
            <div class="text-dark fw-bolder align-middle min-w-100px">
              R$ {{ this.$utils.formatarNumero(faturamento.total) }}
            </div>
          </template>
          <template v-slot:cell-data_emissao="{ row: faturamento }">
            <div class="min-w-100px">
              {{ this.$utils.formatarData(faturamento.data_emissao) }}
            </div>
          </template>
          <template v-slot:cell-nota="{ row: faturamento }">
            <span>{{ faturamento.nota }}</span>
          </template>
          <template v-slot:cell-modelo="{ row: faturamento }">
            <span>{{ faturamento.modelo }}</span>
          </template>
          <template v-slot:cell-serie="{ row: faturamento }">
            <span>{{ faturamento.serie }}</span>
          </template>
          <template v-slot:cell-chave_acesso="{ row: faturamento }">
            <span>{{
              faturamento.FaturamentoChaveNFe &&
              faturamento.FaturamentoChaveNFe.chave_acesso
                ? faturamento.FaturamentoChaveNFe.chave_acesso
                : ""
            }}</span>
          </template>
          <template v-slot:cell-acoes="{ row: faturamento }">
            <div :class="[this.modal === true && 'min-w-200px']">
              <button
                v-if="this.modal === true"
                class="btn btn-sm btn-light-primary me-2"
                @click="selecionarRegistro(faturamento)"
              >
                Selecionar
              </button>
              <button
                class="btn btn-sm btn-light btn-active-light-primary"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="top-end"
              >
                Ações
                <span class="svg-icon svg-icon-5 m-0">
                  <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
                </span>
              </button>
              <div
                v-if="this.editar || this.excluir"
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4"
                data-kt-menu="true"
              >
                <div
                  v-if="this.editar && this.modal === false"
                  class="menu-item px-3"
                >
                  <a @click="editarRegistro(faturamento)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/art/art005.svg"
                        class="me-2"
                      />Editar
                    </span></a
                  >
                </div>
                <div
                  v-if="this.editar && this.modal === true"
                  class="menu-item px-3"
                >
                  <a
                    @click="this.$emit('editarFaturamento', faturamento)"
                    class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/art/art005.svg"
                        class="me-2"
                      />Editar
                    </span></a
                  >
                </div>
                <div v-if="this.excluir" class="menu-item px-3">
                  <a
                    @click="removerRegistro(faturamento)"
                    class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/arrows/arr015.svg"
                        class="me-2"
                      />Excluir
                    </span></a
                  >
                </div>
                <div v-if="faturamento.modelo === '55'" class="menu-item px-3">
                  <a @click="acoesNFe(faturamento)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/general/gen005.svg"
                        class="me-2"
                      />NF-e
                    </span></a
                  >
                </div>
              </div>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
  <AcoesNFeModal
    v-if="this.exibirModalAcoesNFe"
    :id="this.idFaturamento"
    :editar="true"
    @exibirAcoesNFeModal="exibirAcoesNFeModal"
    @confirmarAcoesNFeModal="confirmarAcoesNFeModal"
  >
  </AcoesNFeModal>
</template>

<script>
import { getOrCreateInstanceModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
import AcoesNFeModal from "@/views/faturamento/AcoesNFeModal.vue";
const toast = useToast();

export default {
  emits: [
    "selecionarFaturamento",
    "fecharFaturamento",
    "adicionarFaturamento",
    "editarFaturamento",
  ],
  components: {
    Datatable,
    AcoesNFeModal,
  },
  props: {
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Faturamento.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.Faturamento.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.Faturamento.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
    async editarRegistro(faturamento) {
      if (faturamento.status_nfe.toUpperCase() === "EM DIGITAÇÃO") {
        this.$router.push("/movimentacao/faturamento/editar/" + faturamento.id);
      } else {
        await Swal.fire({
          text: "A situação da nota indica que não está em digitação, não sendo possível editar a mesma!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn fw-bold btn-warning",
          },
        });
      }
    },
    getStatusColor(situacao) {
      if (situacao.toUpperCase() === "EM DIGITAÇÃO") {
        return "badge badge-light-primary";
      } else if (situacao.toUpperCase() === "CANCELADA") {
        return "badge badge-light-danger";
      } else if (situacao.toUpperCase() === "AUTORIZADA") {
        return "badge badge-success";
      } else {
        return "badge badge-light-dark";
      }
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(nota, '" +
          pesquisa +
          "') or contains(status_nfe, '" +
          pesquisa +
          "') or contains(FaturamentoCliente/nome, '" +
          pesquisa +
          "') or contains(FaturamentoCliente/cpf_cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(FaturamentoChaveNFe/chave_acesso, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    async removerRegistro(id) {
      var alert = await Swal.fire({
        text: "Deseja remover o registro?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.tableFaturamento.setLoading(true);
        await this.excluirFaturamento(id);
        if (this.excluiuCadastro === true) {
          toast.success("Faturamento excluído com sucesso!", { timeout: 3000 });
        }
        this.$refs.tableFaturamento.load();
      }
    },
    async excluirFaturamento(faturamento) {
      try {
        if (faturamento.status_nfe.toUpperCase() === "EM DIGITAÇÃO") {
          await this.$store.dispatch(
            "faturamento/deleteFaturamento",
            faturamento.id
          );
        } else {
          await Swal.fire({
            text: "A situação da nota indica que não está em digitação, não sendo possível excluir a mesma!",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn fw-bold btn-warning",
            },
          });
          this.excluiuCadastro = false;
        }
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    exibirAcoesNFeModal(exibir) {
      this.exibirModalAcoesNFe = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_acoes_nfe_modal");
        }, 100);
      }
    },
    async acoesNFe(faturamento) {
      this.idFaturamento = faturamento.id;
      this.exibirAcoesNFeModal(true);
    },
    async confirmarAcoesNFeModal() {
      this.$refs.tableFaturamento.setLoading(true);
      this.$refs.tableFaturamento.load();
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    setTimeout(() => {
      this.nextFocus("txtPesquisarFaturamentos");
    }, 800);
  },
  data() {
    return {
      adicionar: false,
      editar: false,
      excluir: false,
      checkedFaturamentos: [],
      errosValidacaoGeral: [],
      exibirModalAcoesNFe: false,
      idFaturamento: -1,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          key: "FaturamentoClienteClienteFoto",
          sortingField: "FaturamentoCliente/Cliente/foto",
          sortable: false,
        },
        {
          name: "ID",
          key: "id",
          sortable: true,
          dataPriority: "1",
        },
        {
          name: "Cliente",
          key: "FaturamentoClienteNome",
          sortingField: "FaturamentoCliente/nome",
          sortable: true,
        },
        {
          name: "Status",
          key: "status",
          sortable: true,
        },
        {
          name: "Total",
          key: "total",
          sortable: true,
        },
        {
          name: "Emissão",
          key: "data_emissao",
          sortable: true,
        },
        {
          name: "Nota",
          key: "nota",
          sortable: true,
        },
        {
          name: "Modelo",
          key: "modelo",
          sortable: true,
        },
        {
          name: "Série",
          key: "serie",
          sortable: true,
        },
        {
          name: "Chave de Acesso",
          key: "chave_acesso",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "faturamento/getFaturamentoOData",
        selectOData:
          "?$select=id,total,data_emissao,status_nfe,nota,modelo,serie&$expand=FaturamentoCliente($select=nome,cpf_cnpj;expand=Cliente($select=foto))&$expand=FaturamentoChaveNFe($select=chave_acesso)",
        filterOData: "",
        search: "",
        defaultSort: "id desc, modelo, serie desc",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
